import useAppContext from "@casino/legacy/shared/context/AppContext/useAppContext";

const useTelegramAPI = () => {
  const { telegramAPI } = useAppContext();

  return {
    telegramAPI,
  };
};

export default useTelegramAPI;
